<script setup lang="ts">
import { ConnectedAccountsEmbed } from '@/Pejer/tables/ConnectedAccounts'
import { AlertCircleIcon } from 'lucide-vue-next'
import { Alert } from 'pejer/src/components/ui/alert'
import { Badge } from 'pejer/src/components/ui/badge'
import VerticalLine from 'pejer/src/components/VerticalLine.vue'

const props = defineProps<{
  connectedAccount: ConnectedAccountsEmbed.ListItem
  hasValidSignatories: boolean
  signatories: string[]
}>()
</script>
<template>
  <div class="gap-4 w-full flex flex-col justify-center">
    <Alert
      v-if="!props.hasValidSignatories"
      class="bg-yellow-50 text-red-500 font-bold border-yellow-300 text-left items-center flex gap-2"
      variant="default"
    >
      <div class="flex gap-8">
        <div class="flex items-center gap-2">
          <AlertCircleIcon class="w-6 h-6" />
          <span v-if="signatories.length == 0">Alle skal signere</span>
          <span v-else-if="signatories.length == 1">
            OBS! Disse skal signere:
            <br />
            <Badge variant="default">{{ signatories[0] }}</Badge>
          </span>
          <span v-else>
            <span class="font-semibold">OBS! En av følgende kombinasjoner skal signere:</span>
            <ol class="list-decimal w-fit gap-1 flex flex-col ml-4">
              <li v-for="(signatory, index) in signatories" :key="index">
                <Badge variant="default">{{ signatory }}</Badge>
              </li>
            </ol>
          </span>
        </div>
        <VerticalLine class="border-r border-red-300 min-h-14 self-center" />
        <span class="text-red-500 w-fit">
          Vi kan ikke automatisk bekrefte at denne signeringskombinasjonen er gyldig. <br />
          En manuell sjekk vil derfor bli gjennomført av oss før onboardingen kan fullføres. <br />
          Dersom noe er feil kan du legge til manglende signaturer under.
        </span>
      </div>
    </Alert>
    <template v-else>
      <span v-if="signatories.length == 0">Alle skal signere</span>
      <span v-else-if="signatories.length == 1">
        OBS! Disse skal signere:
        <br />
        <Badge variant="default">{{ signatories[0] }}</Badge>
      </span>
      <span v-else>
        <span class="font-semibold">OBS! En av følgende kombinasjoner skal signere:</span>
        <ol class="list-decimal w-fit gap-1 flex flex-col ml-4">
          <li v-for="(signatory, index) in signatories" :key="index">
            <Badge variant="default">{{ signatory }}</Badge>
          </li>
        </ol>
      </span>
    </template>
  </div>
</template>
